const DB_NAME = "binder-admin-notifications";
let sessionEpoch = 0;
export const notificationSessionEpoch = () => sessionEpoch;
export function deviceSettings(value) {
  if (!window.indexedDB) return Promise.resolve(null);
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains("settings")) db.createObjectStore("settings");
      if (!db.objectStoreNames.contains("seen")) db.createObjectStore("seen");
    };
    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      const db = request.result, tx = db.transaction("settings", value ? "readwrite" : "readonly");
      const action = value ? tx.objectStore("settings").put(value, "device") : tx.objectStore("settings").get("device");
      tx.oncomplete = () => { db.close(); resolve(value || action.result || null); };
      tx.onerror = () => { db.close(); reject(tx.error); };
    };
  });
}

export async function stopBrowserNotifications() {
  sessionEpoch += 1;
  // Primero apagar el dispositivo: también protege ante un cierre de sesión sin conexión.
  await deviceSettings({ enabled: false, userId: null, sound: false }).catch(() => {});
  if (!navigator.serviceWorker) return;
  try {
    const registration = await navigator.serviceWorker.getRegistration("/");
    if (!registration) return;
    const subscription = await registration.pushManager.getSubscription();
    const token = localStorage.getItem("token");
    if (subscription) {
      const base = process.env.REACT_APP_DEV_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || "https://dnbinderapi.pruebasistemasgenius.com";
      if (token) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 3000);
        fetch(`${base.replace(/\/$/, "")}/api/notificaciones-admin/desactivar`, { method: "POST", signal: controller.signal,
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: JSON.stringify({ endpoint: subscription.endpoint }) })
          .catch(() => {}).finally(() => clearTimeout(timer));
      }
      await subscription.unsubscribe();
    }
    const notifications = await registration.getNotifications();
    notifications.forEach((notification) => notification.close());
  } catch { /* La configuración local ya quedó apagada. */ }
}
